const ONBOARDING_SURVEY_DISMISSED = 'onboarding-survey-dismissed';

// A user whose answers will not save has to be able to leave the survey, or the
// redirect asks the same question on every render. The dismissal is deliberately not
// written to the server — the answers really are missing — and deliberately not held
// in Redux, which a page reload would wipe and re-trap the user with. sessionStorage
// keeps it for the tab and drops it when the tab closes, next to the Keycloak session
// freshness that `redirectIfNeeded` already reads (PRE-3350).
export function isSurveyDismissed(): boolean {
  return window.sessionStorage.getItem(ONBOARDING_SURVEY_DISMISSED) === 'true';
}

export function dismissSurvey(): void {
  window.sessionStorage.setItem(ONBOARDING_SURVEY_DISMISSED, 'true');
}
